import angular from "angular";
import angularSanitize from "angular-sanitize";

angular
    .module('articleView', [angularSanitize])
    .component('articleView', {
        controller: [controller],
        template: require('./article-view.html'),
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.article = $ctrl.resolve.article;
    };

}

export default 'articleView';


// WEBPACK FOOTER //
// ./resources/assets/modules/articles-control/article-view/article-view.js